/** ID системных шаблонов для массовых операций (запускаются напрямую, без галереи). */
export const TDATA_ONBOARDING_TEMPLATE_ID =
  "1dba4fcb-d824-4350-b022-82c0c737f67d"
export const JOIN_AND_TRACK_TEMPLATE_ID = "0683af38-d46c-4d98-9875-726a2adf15e0"
export const CHAT_EXPORT_TEMPLATE_ID = "03b13770-d713-4785-adc0-7000234b6991"
